import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Search } from 'src/@core/interfaces/search';
import { AppService } from 'src/@core/services/app.service';
import { MarketplaceService } from 'src/@core/services/marketplace.service';
import { permissions } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';
import { BookMarketplaceServicesComponent } from '../book-marketplace-services/book-marketplace-services.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'hour4u-admin-view-marketplace',
  templateUrl: './view-marketplace.component.html',
  styleUrls: ['./view-marketplace.component.scss']
})
export class ViewMarketplaceComponent implements OnInit {
  selectedReviewTabIndex: number = 0;
  isMobileView: boolean = false;
  profile = this.appService.getCurrentAccount();
  portfolio: any = null;
  baseImageUrl = environment.image_url;
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 20;
  pageSizeOptions: number[] = [20, 50, 100, 500];
  servicesList: any[] = [];
  isLoading: boolean = false;
  diameter = 40;
  color: string;
  mode = 'indeterminate';
  entityId: any = null;
  permissions = permissions;
  @Input() fromDigitalPortfolio?: boolean;

  constructor(
    public marketplaceService: MarketplaceService,
    private appService: AppService,
    public router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    if (window.innerWidth <= 768) {
      this.isMobileView = true;
    }
    this.route.params.subscribe(data => {
      console.log(data)
      if (data && Object.keys(data).length === 0) {
      } else if (data && data.id) {
        this.entityId = data.id;
        this.getDigitalPortfolio();
      }
    });
    console.log(this.profile)
    if (this.fromDigitalPortfolio) {
      if (this.profile && this.profile.entity && this.profile.entity.id) {
        this.entityId = this.profile.entity.id;
      }
      this.getDigitalPortfolio();
    }
  }

  getDigitalPortfolio() {
    let entityId = this.entityId;
    console.log("entityId===", entityId)
    if (entityId) {
      this.isLoading = true;
      this.marketplaceService.getDigitalPortfolioById(entityId).subscribe(res => {
        this.isLoading = false;
        if (res && res.content && res.content.length) {
          this.portfolio = res.content[0];
          console.log("this.portfolio===", this.portfolio);
          this.getServicesDetails();
        }
      }, (err => {
        this.isLoading = false;
      }))
    } else {

    }
  }

  getServicesDetails() {
    const searchParams = [];
    this.isLoading = true;
    if (this.portfolio && this.portfolio.entityMeta && this.portfolio.entityMeta.services && this.portfolio.entityMeta.services.length) {
      this.portfolio.entityMeta.services.forEach(element => {
        searchParams.push(new Search('serviceId', element.id))
      });

      this.marketplaceService.getAllServicesDetailsOfDigitalPortfolio(
        // entityId,
        this.pageIndex,
        this.pageSize,
        'createdOn',
        'desc',
        searchParams
      ).subscribe(res => {
        this.isLoading = false;
        this.servicesList = res.content;
        console.log("this.servicesList====", this.servicesList);
        this.resultsLength = res.totalElements;
      }, (err => {
        this.isLoading = false;
      }))
    } else {
      this.isLoading = false;
    }
  }

  editPortfolio(portfolio: any) {
    this.router.navigateByUrl('/digital-portfolio/form/' + portfolio.id);
  }

  onTabChanged(event) {

  }

  bookService(service) {
    console.log(service)
    let obj = {
      portfolio: this.portfolio,
      service: service
    }
    const dialogRef = this.dialog.open(BookMarketplaceServicesComponent, {
      width: '500px',
      disableClose: true,
      data: obj
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
